import React, { useEffect, useState } from "react";

//*MUI
import { Modal, Box, Switch, FormControl, RadioGroup, FormControlLabel, Radio } from "@mui/material";

//*redux
import { useDispatch } from "react-redux";
import action from "../../Redux Store/actions";

//*files
import cssClasses from "./AddPaymentPlan.module.css";
import Button from "../../Subcomponents/Button";
import Close from "../../Components/Icons/Close";
import DropDown from "../../Subcomponents/DropDown";
import CustomInput from "../../Subcomponents/CustomInput";
import {
  AddPaymentPlansToData,
  CheckPaymentPlansDetails,
  getPaymentPlansPriceFromDb,
  getProjectDataByProjectId,
  insertPaymentPlanPrice,
  updatePaymentPlanPrice,
  UpdatePaymentPlansToData,
} from "../../Services/Project";
import { useParams } from "react-router-dom";
import {
  getWingsByProjectId,
  getInventoryTypeFromProjectName,
  getProjectByProjectName,
  getAllWingsByProjectId,
  getInventoryTypeFromProjectWing,
  getInventoryTypeFromProjectWing1,
} from "../../Services/SustenanceService";
import { errorTost, infoTost, successTost } from "../../Services/Toast";
import _, { uniqBy } from "lodash";
import RupeeIcon from '../../Assets/Images/Sustenance/RupeeIcon.svg';
import { dismissLoader, presentLoader } from "../../Services/loader";
import * as XLSX from "xlsx";
import CustomSwitch from "../../Subcomponents/CustomSwitch";
import FieldEntriesModal from "../FieldEntriesModal/FieldEntriesModal";
const style = {
  position: "absolute",
  top: "45%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "69%",
  width: "Fit-Content",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
};

export default function AddPaymentPlan({
  open,
  handleClose,
  PaymentAddedResp,
  data,
  ModalType,
  selectedWings,
  allSelectedInventory,
  setOpen
}) {
  const dispatch = useDispatch();
  const { projectId } = useParams();
  const [InventoryType, setInventoryType] = useState([]);
  const [WingsData, setWingsData] = useState([]);
  const [ProjectData, setProjectData] = useState([]);
  const [WingNames, setWingNames] = useState("");
  const [BhkValue, setBhkValue] = useState("");
  const [uploadExcelFile, setUploadExcelFile] = useState(null);
  const [totalEntries, setTotalEntries] = useState(0);
  const [successEntries, setSuccessEntries] = useState(0);
  const [failedEntries, setFailedEntries] = useState(0);
  const [csvAdded, setCsvAdded] = useState(false);
  const [sdrPercent, setSdrPercent] = useState(null);
  const [registrationCharges, setregistrationCharges] = useState(null);
  const [legalChargeVal, setLegalChargeVal] = useState(null);
  const [isFailedEntries, setIsFailedEntries] = useState(false);
  const [failedEntriesArray, setFailedEntriesArray] = useState([]);

  useEffect(() => {
    dispatch(action.activeMenu("project"));
    getProjectData();

    if (ModalType === "Edit") {
      console.info("Edit-payment-Data", data);
      setPaymentPlanDetails((pre) => {
        pre.Wings = data.wingId.wingId;
        pre.wingName = data.wingId.wingName;
        pre.UnitType = data.displayUnitType;
        pre.title = data.Title;
        pre.titleForMatch = data.titleForMatch;
        pre.displayUnitType = data.displayUnitType
        pre.isDisabled = data?.isDisabled;
        // pre.discount = data.Discount;
        return { ...pre };
      });
      // setPaymentPlanDetails([...data])
    }
  }, []);

  const [PaymentPlanDetails, setPaymentPlanDetails] = useState({
    Wings: "",
    wingName: "",
    UnitType: "",
    title: "",
    titleForMatch: "",
    displayUnitType: "",
    isDisabled: false
  });
  const [HelperText, setHelperText] = useState({
    Wings: "",
    UnitType: "",
    title: "",
  });

  useEffect(() => {
    console.log('PaymentPlanDetails.Wings: ', PaymentPlanDetails.Wings);
    if (PaymentPlanDetails.Wings !== '') {
      getInventoryTypeFromProjectWing(projectId, PaymentPlanDetails.Wings)
        .then((response22) => {
          console.log("Unit-type-Dropdown", response22);
          // ? get uniq in
          const unitTypes = _.uniqBy(response22.data, 'displayUnitType');
          const payload = unitTypes?.filter(i => i?.displayUnitType !== null)?.map(v => {
            const obj = { ...v }
            return obj
          })
          setInventoryType(payload ? payload : []);
        })
        .catch((err) => {
          console.log("Inventory-type-err", err);
        });
    }
  }, [PaymentPlanDetails.Wings])

  function getProjectData() {
    console.log("----", projectId);
    getProjectByProjectName(projectId).then((response) => {
      console.log("RESPonse", response);
      setProjectData(response.data);
      setSdrPercent(response?.data[0]?.sdrPercentage);
      setLegalChargeVal(response?.data[0]?.legalCharges);
      setregistrationCharges(response?.data[0]?.registrationCharges);
    });

    //*Wings-DropDown
    getWingsByProjectId(projectId)
      .then((response) => {
        console.log("Wings-Dropdown-Data", response);
        const responseData = uniqBy(response.data, "wingId");
        const payload = []
        responseData?.forEach(v => {
          Object.keys(selectedWings).forEach(w => {
            if (selectedWings[w].isSelected) {
              if (v?.wingName === w) {
                payload.push(v)
              }
            }
          })
        })
        setWingsData(payload);
      })
      .catch((err) => {
        console.log("wings-data", err);
      });

    //*unitType-Dropdown
    // getInventoryTypeFromProjectName(projectId)
    // ! vedashree cahnges ==> getting duplicate records
    // console.log('PaymentPlanDetails.Wings: ', PaymentPlanDetails.Wings);
    // getInventoryTypeFromProjectWing(projectId, PaymentPlanDetails.Wings)
    //   .then((response22) => {
    //     console.log("Unit-type-Dropdown", response22);
    //     setInventoryType(response22.data);
    //   })
    //   .catch((err) => {
    //     console.log("Inventory-type-err", err);
    //   });
  }

  function OnSubmit() {
    presentLoader();
    if (ModalType === "Edit") {
      console.log(" PaymentPlanDetails.title", PaymentPlanDetails.title);
      console.log(" PaymentPlanDetails.discount", PaymentPlanDetails.discount);
      CheckPaymentPlansDetails(
        projectId,
        PaymentPlanDetails.Wings,
        PaymentPlanDetails.UnitType,
        PaymentPlanDetails.titleForMatch,
        data?.paymentPlanId,
      ).then((response11) => {
        console.log("Check-Table", response11);
        if (response11.count === 0) {
          let postBody = {
            title: PaymentPlanDetails.title,
            titleForMatch: (PaymentPlanDetails.title).toUpperCase(),
            key:
              PaymentPlanDetails.title.toUpperCase().replace(/ /g, "") + " " +
              PaymentPlanDetails.displayUnitType + " " +
              WingNames + " " +
              ProjectData[0]?.projectShortCode,
            displayUnitType: PaymentPlanDetails.displayUnitType,
            isDisabled: PaymentPlanDetails.isDisabled
          };

          console.info("postBody", postBody);
          UpdatePaymentPlansToData(postBody, data.paymentPlanId)
            .then((response) => {
              console.log("Updated-successfully", response);
              handleClose();
              PaymentAddedResp(true);
              if (uploadExcelFile?.length > 0) {
                getPaymentPlansPriceFromDb(projectId).then(async (paymentResp) => {
                  if (paymentResp?.data?.length > 0) {
                    const payload = []
                    paymentResp?.data?.map(v => {
                      const selectedUnit = uploadExcelFile?.find(i => i.unitId === v.unitId && v?.paymentPlanId === data?.paymentPlanId)
                      if (selectedUnit) {
                        payload.push({ ...v, BSP: selectedUnit?.BSP, GST: selectedUnit?.GST, SDR: selectedUnit?.SDR, totalCost: selectedUnit?.totalCost, paymentPlanId: data?.paymentPlanId })
                      }
                    })
                    payload.map(async (r) => {
                      await updatePaymentPlanPrice(r).then(updateResp => { })
                    })
                  }
                  const insertPayload = []
                  uploadExcelFile?.forEach(v => {
                    const selectedUnit = paymentResp?.data?.find(i => i.unitId === v.unitId && i?.paymentPlanId === data?.paymentPlanId)
                    if (!selectedUnit) {
                      insertPayload.push({ ...v, paymentPlanId: data?.paymentPlanId })
                    }
                  })
                  if (insertPayload?.length > 0) {
                    insertPayload.map(async (p) => {
                      await insertPaymentPlanPrice(p).then(insertResp => { })
                    })
                  }
                  if (data?.title !== PaymentPlanDetails?.title) {
                    successTost(
                      `Payment plan ${PaymentPlanDetails.title} and prices updated successfully!`
                    );
                  } else {
                    successTost(
                      `Payment plan prices updated successfully!`
                    );
                  }
                  dismissLoader();
                }).catch(err => {
                  dismissLoader()
                  errorTost(err.message)
                })
              } else {
                successTost(`Payment plan ${PaymentPlanDetails.title} updated successfully!`);
                dismissLoader();
              }
            })
            .catch((err) => {
              console.error("Updated-successfully", err);
              dismissLoader();
              errorTost(err.message)
            });
        } else {
          infoTost(` Wing ${PaymentPlanDetails?.wingName} and ${PaymentPlanDetails?.UnitType} and ${PaymentPlanDetails.title} already exists!`);
          dismissLoader();
        }
      })

    } else {
      CheckPaymentPlansDetails(
        projectId,
        PaymentPlanDetails.Wings,
        PaymentPlanDetails.UnitType,
        PaymentPlanDetails.titleForMatch
      ).then((response11) => {
        console.log("Check-Table", response11);
        if (response11.count === 0) {
          let PaymentObj = {
            wingId: PaymentPlanDetails.Wings,
            projectId: projectId,
            key:
              PaymentPlanDetails.title.toUpperCase().replace(/ /g, "") + " " +
              PaymentPlanDetails.displayUnitType + " " +
              WingNames + " " +
              ProjectData[0]?.projectShortCode,
            title: PaymentPlanDetails.title,
            titleForMatch: (PaymentPlanDetails.title).toUpperCase(),
            displayUnitType: PaymentPlanDetails.displayUnitType,
            isDisabled: PaymentPlanDetails.isDisabled
          };

          AddPaymentPlansToData(PaymentObj)
            .then((res) => {
              console.log("Added-Payments-Data", res);
              handleClose();
              PaymentAddedResp(true);
              if (uploadExcelFile?.length > 0) {
                getPaymentPlansPriceFromDb(projectId).then(async (paymentResp) => {
                  if (paymentResp?.data?.length > 0) {
                    const payload = []
                    paymentResp?.data?.map(v => {
                      const selectedUnit = uploadExcelFile?.find(i => i.unitId === v.unitId && v?.paymentPlanId === res?.data[0]?.paymentPlanId)
                      if (selectedUnit) {
                        payload.push({ ...v, BSP: selectedUnit?.BSP, GST: selectedUnit?.GST, SDR: selectedUnit?.SDR, totalCost: selectedUnit?.totalCost, paymentPlanId: res?.data[0]?.paymentPlanId })
                      }
                    })
                    payload.map(async (r) => {
                      await updatePaymentPlanPrice(r).then(updateResp => { })
                    })
                  }
                  const insertPayload = []
                  uploadExcelFile?.forEach(v => {
                    const selectedUnit = paymentResp?.data?.find(i => i.unitId === v.unitId && i?.paymentPlanId === res?.data[0]?.paymentPlanId)
                    if (!selectedUnit) {
                      insertPayload.push({ ...v, paymentPlanId: res?.data[0]?.paymentPlanId })
                    }
                  })
                  if (insertPayload?.length > 0) {
                    insertPayload.map(async (p) => {
                      await insertPaymentPlanPrice(p).then(insertResp => { })
                    })
                  }
                  successTost(`Payment plan ${PaymentPlanDetails.title} and prices added successfully!`);
                  dismissLoader();
                }).catch(err => {
                  dismissLoader()
                  errorTost(err.message)
                })
              } else {
                successTost(`Payment plan ${PaymentPlanDetails.title} added successfully!`);
                dismissLoader();
              }
            })
            .catch((err) => {
              console.log("Payments-Data-add-err", err);
              dismissLoader();
              errorTost(err.message)
            });

        } else {
          infoTost(` Wing ${WingNames} and ${BhkValue} and ${PaymentPlanDetails.title} already exists!`);
          dismissLoader();
        }
      });
    }
  }

  const handleDownloadCSV = () => {
    presentLoader()
    getPaymentPlansPriceFromDb(projectId).then((resp) => {
      dismissLoader()
      if (resp?.data?.length > 0) {
        const payload = []
        allSelectedInventory?.filter(i => i?.displayUnitType === PaymentPlanDetails?.UnitType && i?.wingId?.wingId === PaymentPlanDetails?.Wings)?.forEach(v => {
          const selectedInventory = resp?.data?.find(i => i?.unitId === v?.unitId && (ModalType === "Edit" ? i?.paymentPlanId === data?.paymentPlanId : i?.paymentPlanId === null))
          if (selectedInventory) {
            payload.push({ ...v, BSP: selectedInventory?.BSP, GST: selectedInventory?.GST, SDR: selectedInventory?.SDR, totalCost: selectedInventory?.totalCost })
          } else {
            payload.push({ ...v, BSP: v?.BSP, GST: v?.GST, SDR: v?.SDR, totalCost: v?.totalCost })
          }
        })
        downloadExcelTemplate(payload)
      } else {
        const payload = []
        allSelectedInventory?.filter(i => i?.displayUnitType === PaymentPlanDetails?.UnitType && i?.wingId?.wingId === PaymentPlanDetails?.Wings)?.forEach(v => {
          payload.push({ ...v, BSP: v?.BSP, GST: v?.GST, SDR: v?.SDR, totalCost: v?.totalCost })
        })
        downloadExcelTemplate(payload)
      }
    }).catch((err) => {
      dismissLoader()
      errorTost(err.message)
    })
  }

  const handleUploadCSV = () => {
    let htmlElement = document.createElement('input');
    htmlElement.type = 'file';
    htmlElement.accept =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
    htmlElement.multiple = false;
    htmlElement.click();
    htmlElement.onchange = onChangeSelectExcel;
  }

  function onChangeSelectExcel(e) {
    presentLoader();
    let _file = e.target.files[0];
    if (_file) {
      setCsvAdded(true);
      const reader = new FileReader();
      reader.onload = function (e) {
        var data = e.target.result;
        data = new Uint8Array(data);
        var workbook = XLSX.read(data, {
          type: "array",
          cellText: false,
          cellDates: true,
        });
        var roa;
        workbook.SheetNames.forEach(function (sheetName) {
          roa = XLSX.utils.sheet_to_row_object_array(
            workbook.Sheets[sheetName],
            { raw: false, dateNF: "yyyy-mm-dd" }
          );
        });
        setTimeout(() => {
          console.log("ROA", roa);
          setTotalEntries(roa?.length);
          validatingExcelData(roa);
        }, 1000);
      }
      reader.readAsArrayBuffer(_file);
    } else {
      dismissLoader();
      errorTost('Please select valid excel file.');
    }
  }

  // async function validatingExcelData(_excelDataList) {
  //   const payload = [];
  //   const failedPayload = [];
  //   _excelDataList?.forEach((v) => {
  //     if (
  //       v?.["Agreement Value"] !== "" &&
  //       v?.SDR !== "" &&
  //       v?.GST !== "" &&
  //       v?.TotalCost !== ""
  //     ) {
  //       if (
  //         v?.["Agreement Value"]?.trim()?.length > 0 &&
  //         v?.SDR?.trim()?.length > 0 &&
  //         v?.GST?.trim()?.length > 0 &&
  //         v?.TotalCost?.trim()?.length > 0
  //       ) {
  //         if (
  //           /^[A-Za-z0-9 ]+$/.test(v?.["Agreement Value"]) &&
  //           /^[A-Za-z0-9 ]+$/.test(v?.GST) &&
  //           /^[A-Za-z0-9 ]+$/.test(v?.SDR) &&
  //           /^[A-Za-z0-9 ]+$/.test(v?.TotalCost)
  //         ) {
  //           if (
  //             !/^[a-zA-Z]+$/.test(v?.["Agreement Value"]) &&
  //             !/^[a-zA-Z]+$/.test(v?.GST) &&
  //             !/^[a-zA-Z]+$/.test(v?.SDR) &&
  //             !/^[a-zA-Z]+$/.test(v?.TotalCost)
  //           ) {
  //             if (
  //               v?.["Sales App Status"] === "Available" ||
  //               v?.["Sales App Status"] === "On Hold" ||
  //               v?.["Sales App Status"] === "Preselected" ||
  //               v?.["Sales App Status"] === "Kyc Pending" ||
  //               v?.["Sales App Status"] === "Kyc Done"
  //             ) {
  //               const selectedPayload = allSelectedInventory
  //                 ?.filter(
  //                   (i) => i?.displayUnitType === PaymentPlanDetails?.UnitType
  //                 )
  //                 ?.find((i) => i?.unitNo === v?.unitNo && i?.wingName === v?.Wing);
  //                 console.log("selectedPayload", selectedPayload);
  //               if (selectedPayload) {
  //                 payload.push({
  //                   unitId: selectedPayload?.unitId,
  //                   projectId: projectId,
  //                   BSP: v?.["Agreement Value"],
  //                   GST: v?.GST,
  //                   SDR: v?.SDR,
  //                   totalCost: v?.TotalCost,
  //                 });
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   });
  //   console.log("Uploading Payload", payload);
  //   setSuccessEntries(payload?.length)
  //   setUploadExcelFile(payload);
  // }

  async function validatingExcelData(_excelDataList) {
    const payload = [];
    const failedPayload = [];
    presentLoader()
    _excelDataList?.forEach((v, index) => {
      const result = validateExcelObj(v);
      if (result?.validation?.isValid === true) {
        const selectedPayload = allSelectedInventory?.filter((i) => i?.displayUnitType === PaymentPlanDetails?.UnitType && i?.wingId?.wingId === PaymentPlanDetails?.Wings)?.find((i) => i?.unitNo === v?.unitNo && i?.wingId?.wingName === v?.Wing);
        if (selectedPayload) {
          payload.push({
            unitId: selectedPayload?.unitId,
            projectId: projectId,
            BSP: v?.["Agreement Value"],
            GST: v?.GST,
            SDR: v?.SDR,
            totalCost: v?.TotalCost,
          });
        }
      } else {
        const obj = {
          ...v,
          id: index,
          BSP: v?.["Agreement Value"],
          reason: result?.validation?.reason
        };
        failedPayload.push(obj);
      }
    });
    dismissLoader()
    setSuccessEntries(payload?.length);
    setFailedEntries(failedPayload?.length);
    setFailedEntriesArray(failedPayload);
    setUploadExcelFile(payload);
  }

  function validateExcelObj(excelObj) {
    const validation = {
      isValid: true,
      reason: ''
    };
    const selectedPayload = allSelectedInventory?.filter((i) => i?.displayUnitType === PaymentPlanDetails?.UnitType && i?.wingId?.wingId === PaymentPlanDetails?.Wings)?.find((i) => i?.unitNo === excelObj?.unitNo && i?.wingId?.wingName === excelObj?.Wing);

    if (!selectedPayload) {
      validation.isValid = false;
      validation.reason = validation.reason === '' ? 'Combination of Unit Type and Wing not matched' : validation.reason + ", Combination of Unit Type and Wing not matched";
    }

    if (!excelObj.Wing || excelObj.Wing === "") {
      validation.isValid = false;
      validation.reason = validation.reason === '' ? 'Wing is empty' : validation.reason + ", Wing is empty";
    }

    if (!excelObj.unitNo || excelObj.unitNo === "") {
      validation.isValid = false;
      validation.reason = validation.reason === '' ? 'unitNo is empty' : validation.reason + ", unitNo is empty";
    }

    if (!excelObj.UnitType || excelObj.UnitType === "") {
      validation.isValid = false;
      validation.reason = validation.reason === '' ? 'UnitType is empty' : validation.reason + ", UnitType is empty";
    }

    if (excelObj.Area === null || excelObj.Area === undefined || isNaN(excelObj.Area) || excelObj.Area === "") {
      validation.isValid = false;
      validation.reason = validation.reason === '' ? 'Area is empty' : validation.reason + ", Area is empty";
    }

    //Check if Agreement Value is Null
    if (excelObj['Agreement Value'] === null || excelObj['Agreement Value'] === undefined || isNaN(excelObj['Agreement Value']) || excelObj['Agreement Value'] === "") {
      validation.isValid = false;
      validation.reason = validation.reason === '' ? 'Agreement value is invalid' : validation.reason + ", Agreement Value is invalid";
    } else {
      let sdrVal = 0;
      let gstVal = 0;
      let TotalCostValue = 0;

      //Check if GST is Null
      if (excelObj.GST === null || excelObj.GST === undefined || isNaN(excelObj.GST) || excelObj.GST === "") {
        validation.isValid = false;
        validation.reason = validation.reason === '' ? 'GST is invalid' : validation.reason + ", GST is invalid";
      } else {
        gstVal = Math.round(excelObj['Agreement Value'] < 4500000 ? 1 / 100 * excelObj['Agreement Value'] : 5 / 100 * excelObj['Agreement Value'])
        if (+excelObj.GST !== gstVal && +excelObj.GST > 0) {
          validation.isValid = false;
          validation.reason = validation.reason === '' ? excelObj['Agreement Value'] < 4500000 ? `GST Value is not 1% of ${excelObj['Agreement Value']}` : `GST Value is not 5% of ${excelObj['Agreement Value']}` : validation.reason + excelObj['Agreement Value'] < 4500000 ? `GST Value is not 1% of ${excelObj['Agreement Value']}` : `GST Value is not 5% of ${excelObj['Agreement Value']}`;
        }
      }
      //Check if SDR if Null
      if (excelObj.SDR === null || excelObj.SDR === undefined || isNaN(excelObj.SDR) || excelObj.SDR === "") {
        validation.isValid = false;
        validation.reason = validation.reason === '' ? 'SDR is invalid' : validation.reason + ", SDR is invalid";
      } else {

        sdrVal = ((Math.ceil((Math.round((Number(excelObj['Agreement Value']) * (sdrPercent)) / 100)) / 100) * 100) +
          (Number(excelObj['Agreement Value']) > 3000000
            ? (Math.ceil(Number(registrationCharges / 100) * 100))
            : (Math.ceil(Number(excelObj['Agreement Value'] / 100) / 100) * 100)) +
          legalChargeVal)
        if (+excelObj.SDR !== sdrVal && +excelObj.SDR > 0) {
          validation.isValid = false;
          validation.reason = validation.reason === '' ? `SDR Value is not ${sdrPercent}% of ${excelObj['Agreement Value']} ` : validation.reason + ` SDR Value is not ${sdrPercent}% of ${excelObj['Agreement Value']} `;
        }
      }

      //Check if Total is Null
      if (excelObj.TotalCost === null || excelObj.TotalCost === undefined || isNaN(excelObj.TotalCost) || excelObj.TotalCost === "") {
        validation.isValid = false;
        validation.reason = validation.reason === '' ? 'TotalCost is invalid' : validation.reason + ", TotalCost is invalid";
      } else {
        TotalCostValue = Math.round((+excelObj.SDR > 0 ? sdrVal : 0) + parseInt(excelObj['Agreement Value']) + (+excelObj.GST > 0 ? gstVal : 0))
        if (+excelObj.TotalCost !== TotalCostValue && +excelObj.TotalCost > 0) {
          validation.isValid = false;
          validation.reason = validation.reason === '' ? 'TotalCost is incorrect' : validation.reason + ", TotalCost is incorrect";
        }
      }
    }

    if (!(excelObj["Sales App Status"] === "Available" || excelObj["Sales App Status"] === "On Hold" || excelObj["Sales App Status"] === "Preselected" || excelObj["Sales App Status"] === "Kyc Pending" || excelObj["Sales App Status"] === "Kyc Done")) {
      validation.isValid = false;
      validation.reason = validation.reason === '' ? "Invalid Sales app status" : validation.reason + ", Invalid Sales app status";
    }

    return { validation, excelObj };
  }

  async function downloadExcelTemplate(allInventory) {
    presentLoader();
    let _list = [];

    const getAvailableUnitsOnly = allInventory.filter(
      (f) =>
        f.inventoryStatusId.status === 'Available' ||
        f.inventoryStatusId.status === 'On Hold' ||
        f.inventoryStatusId.status === 'Preselected' ||
        f.inventoryStatusId.status === 'Kyc Pending' ||
        f.inventoryStatusId.status === 'Kyc Done'
    );
    for (const _item of getAvailableUnitsOnly) {
      console.log('_Item', _item);
      const pricingObjPerUnit = {
        Wing: _item.wingName,
        unitNo: _item.unitNo,
        UnitType: _item.inventoryTypeId.type,
        Area: _item.saleableArea,
        'Sales App Status': _item.inventoryStatusId.status,
        'FV Status': _item.farvisionStatus,
        'Agreement Value': _item?.BSP,
        GST: _item?.GST,
        SDR: _item?.SDR,
        TotalCost: _item?.totalCost,

      };
      console.log('pricingObjPerUnit', pricingObjPerUnit);
      _list.push(pricingObjPerUnit);
    }
    const worksheet = XLSX.utils.json_to_sheet(_list);
    const workBook = new XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, worksheet, "Price list Units");
    XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    XLSX.writeFile(
      workBook,
      ProjectData[0].projectName + ` Price list Units Template.xlsx`
    );
    dismissLoader();
  }
  return (
    <>
      <Modal
        open={open}
        onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
      >
        <Box sx={style}>
          <Box className={cssClasses.headerDiv}>
            <Box className={cssClasses.flexRow}>
              <Box className={cssClasses.flexCol}>
                {ModalType !== "Edit" && (
                  <Box className={cssClasses.HeaderTitle} mt={1}>
                    Add Payment Plan
                  </Box>
                )}
                {ModalType === "Edit" && (
                  <Box className={cssClasses.HeaderTitle} mt={1}>
                    Edit Payment Plan
                  </Box>
                )}
              </Box>
              <Box
                ml={"auto"}
                mt={1}
                onClick={handleClose}
                style={{ cursor: "pointer" }}
              >
                <Close width={"1.2rem"} height={"1.2rem"} />
              </Box>
            </Box>
          </Box>

          <Box height={"80%"} width={"100%"} overflow={"auto"}>
            <Box margin={"2rem"}>

              <Box className={cssClasses.flexRow1} >
                <Box className={cssClasses.InputTitle}  >
                  Wing
                  <span className={cssClasses.Star}>*</span>
                </Box>
                <Box className={cssClasses.widthBox}>
                  <DropDown
                    placeHolder={"Select"}
                    list={WingsData.map((ele, id) => {
                      return {
                        label: ele.wingName,
                        value: ele.wingId,
                      };
                    })}
                    selectedValue={PaymentPlanDetails.Wings}
                    disable={ModalType === "Edit"}
                    onChangeSelect={(value) => {
                      console.log("------>", value);
                      const wingName = WingsData.find(
                        (p) => p.wingId === value
                      );
                      console.log("WingsName", wingName.wingName);
                      setWingNames(wingName.wingName);
                      setPaymentPlanDetails((pre) => {
                        pre.Wings = value;
                        return { ...pre };
                      });
                      setUploadExcelFile(null)
                      setCsvAdded(false)
                    }}
                    label
                    style={{
                      background: "#F2F4F7",
                      selectedColor: "#667085",
                    }}
                  />
                </Box>
              </Box>

              <Box className={cssClasses.flexRow1}>
                <Box className={cssClasses.InputTitle}>
                  Unit type
                  <span className={cssClasses.Star}>*</span>
                </Box>
                <Box className={cssClasses.widthBox}>
                  <DropDown
                    placeHolder={"Select"}
                    list={InventoryType
                      .map((m) => ({
                        label: m.displayUnitType,
                        value: m.displayUnitType,
                      }))}
                    selectedValue={PaymentPlanDetails.UnitType}
                    disable={
                      PaymentPlanDetails?.Wings === "" || ModalType === "Edit"
                    }
                    onChangeSelect={(value) => {
                      console.log("unitType===>", value);
                      const UnitTypeValue = InventoryType.find(
                        (f) => f.displayUnitType === value
                      );
                      setBhkValue(UnitTypeValue.displayUnitType);
                      setPaymentPlanDetails((pre) => {
                        pre.UnitType = value;
                        pre.displayUnitType = UnitTypeValue.displayUnitType
                        return { ...pre };
                      });
                      setUploadExcelFile(null)
                      setCsvAdded(false)
                    }}
                    style={{
                      background: "#F2F4F7",
                      selectedColor: "#667085",
                    }}
                  />
                </Box>
              </Box>

              <Box className={cssClasses.flexRow1} >
                <Box className={cssClasses.InputTitle} >
                  Title
                  <span className={cssClasses.Star}>*</span>
                </Box>
                <Box className={cssClasses.widthBox}>
                  <CustomInput
                    inputType={"text"}
                    placeholder={"Enter title"}
                    value={PaymentPlanDetails.title}
                    disabled={PaymentPlanDetails.UnitType === ""}
                    handleChange={(_value) => {
                      const regex = /^[a-zA-Z0-9 _-]+$/;
                      const trimmedValue = _value.trim();
                      if (_value === '' || regex.test(trimmedValue)) {
                        setPaymentPlanDetails((pre) => {
                          pre.title = _value;
                          pre.titleForMatch = _value.toUpperCase();
                          return { ...pre };
                        });
                      } else {
                        console.log("Invalid Character")
                      }
                    }}
                  />
                </Box>
              </Box>
              <Box className={cssClasses.flexRow1} >
                <Box className={cssClasses.toggle} >
                  Disable
                  {/* <span className={cssClasses.Star}>*</span> */}
                </Box>
                <Box className={cssClasses.widthBox}>
                  <CustomSwitch
                    checked={PaymentPlanDetails.isDisabled}
                    onChange={(event) => {
                      setPaymentPlanDetails((pre) => {
                        pre.isDisabled = event.target.checked;
                        return { ...pre };
                      });
                    }}
                  />
                </Box>
              </Box>
              <Box display={"flex"} flex={"column"} gap={"1rem"} marginTop={"2rem"} marginBottom={"1.5rem"}>
                <Button
                  style={{
                    color: "#344054",
                    backgroundColor: "#ffffff",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  padding={"0.85rem 3rem"}
                  btnName={"Download CSV"}
                  disable={PaymentPlanDetails.UnitType === ""}
                  clicked={() => handleDownloadCSV()}
                />
                <Button
                  style={{
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                    color: "#ffffff",
                    backgroundColor: "#155EEF",
                  }}
                  padding={"0.85rem 3rem"}
                  btnName={"Upload CSV"}
                  disable={PaymentPlanDetails.UnitType === ""}
                  clicked={() => handleUploadCSV()}
                />
              </Box>

              {csvAdded && <Box style={{ marginTop: "3rem", display: "flex", flexDirection: "column", gap: "2rem" }} >
                <div className={cssClasses.flexRow2}>
                  <Box className={cssClasses.InputTitle2}>
                    Total Entries
                  </Box>
                  <Box className={cssClasses.InputTitle2}>
                    {totalEntries}
                  </Box>
                </div>
                <div className={cssClasses.flexRow2}>
                  <Box className={cssClasses.InputTitle2} >
                    Success Entries
                  </Box>
                  <Box className={cssClasses.InputTitle2}>
                    {successEntries}
                  </Box>
                </div>
                <div className={cssClasses.flexRow2}>
                  <Box className={cssClasses.InputTitle2} >
                    Failed Entries
                  </Box>
                  <Box className={cssClasses.InputTitle2}>
                    {failedEntries}
                  </Box>
                </div>
                <div>
                  {failedEntriesArray?.length > 0 &&
                    <Box >
                      <Button
                        style={{
                          color: "#344054",
                          backgroundColor: "#ffffff",
                          fontSize: "1.6rem",
                          lineHeight: "2.4rem",
                        }}
                        padding={"0.85rem 3rem"}
                        btnName={"View Failed Entries"}
                        // disable={""}
                        clicked={() => setIsFailedEntries(true)}
                      />
                    </Box>}
                </div>
              </Box>}
              {/* <Box>
                <Box className={cssClasses.InputTitle} mt={1.5}>
                  Type
                  <span className={cssClasses.Star}>*</span>
                </Box>
                
                <Switch
                  checked={PaymentPlanDetails.type}
                  onChange={(event) => {
                    setPaymentPlanDetails((pre) => {
                      pre.type = event.target.checked;
                      return { ...pre };
                    });
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Box> */}
              {/* <div>
                <Box className={cssClasses.flexRow1} >
                  <Box className={cssClasses.InputTitle} >
                    Operation
                    <span className={cssClasses.Star}>*</span>
                  </Box>
                  <Box className={cssClasses.widthBox}>
                    <DropDown
                      placeHolder={"Select"}
                      list={['Discount', 'Add']}
                      selectedValue={PaymentPlanDetails.operation}
                      onChangeSelect={(value) => {
                        setPaymentPlanDetails((pre) => {
                          pre.operation = value;
                          return { ...pre };
                        });
                      }}
                      label
                      style={{
                        background: "#F2F4F7",
                        selectedColor: "#667085",
                      }}
                    />
                  </Box>
                </Box>
                <Box className={cssClasses.flexRow1} >
                  <Box className={cssClasses.InputTitle} >
                    Type
                    <span className={cssClasses.Star}>*</span>
                  </Box>
                  <Box className={cssClasses.widthBox}>
                    <DropDown
                      placeHolder={"Select"}
                      list={['Fixed', 'Percentage']}
                      selectedValue={PaymentPlanDetails.type}
                      onChangeSelect={(value) => {
                        let discountVal = PaymentPlanDetails.discount;
                        if (value === 'Percentage' && parseInt(PaymentPlanDetails.discount) > 100) {
                          // discountVal = parseInt(PaymentPlanDetails.discount).toFixed(2);
                          discountVal = '';
                        }
                        setPaymentPlanDetails((pre) => {
                          pre.type = value;
                          pre.discount = discountVal;
                          return { ...pre };
                        });

                      }}
                      label
                      style={{
                        background: "#F2F4F7",
                        selectedColor: "#667085",
                      }}
                    />
                  </Box>
                </Box>
              </div>
              <Box className={cssClasses.flexRow1} >
                <Box className={cssClasses.InputTitle} >
                  Amount
                  {
                    PaymentPlanDetails.type === 'Fixed' && <span>(₹)</span>
                  }
                  {
                    PaymentPlanDetails.type === 'Percentage' && <span>(%)</span>
                  }
                  <span className={cssClasses.Star}>*</span>
                </Box>
                <Box className={cssClasses.widthBox}>
                  <CustomInput
                    placeholder={PaymentPlanDetails.type === 'Fixed' ? "Enter amount in Rupees" : 'Enter amount in percentage'}
                    inputType={"number"}
                    // position={'start'}
                    // image={PaymentPlanDetails.type === 'Fixed' ? true : false}
                    // labelText={PaymentPlanDetails.type === 'Fixed' ? RupeeIcon : '%'}
                    disabled={PaymentPlanDetails.title === ""}
                    value={PaymentPlanDetails.discount}
                    handleChange={(_value) => {
                      if (_value > 0) {
                        if (PaymentPlanDetails.type === 'Percentage') {
                          if (_value <= 100) {
                            setPaymentPlanDetails((pre) => {
                              pre.discount = _value;
                              return { ...pre };
                            });
                          }
                        } else {
                          setPaymentPlanDetails((pre) => {
                            pre.discount = _value;
                            return { ...pre };
                          });
                        }
                      }
                    }}
                  />
                </Box>
              </Box> */}
            </Box>
          </Box>

          <Box className={cssClasses.FooterDiv}>
            <Box className={cssClasses.flexRow}>
              <Box width={"fit-Content"} ml={"auto"}>
                <Button
                  style={{
                    color: "#344054",
                    backgroundColor: "#ffffff",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  padding={"0.85rem 2.6rem"}
                  btnName={"Cancel"}
                  clicked={handleClose}
                />
              </Box>

              <Box width={"fit-Content"}>
                <Button
                  style={{
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                    color: "#ffffff",
                    backgroundColor: "#155EEF",
                  }}
                  disable={PaymentPlanDetails.UnitType === "" || PaymentPlanDetails?.title === "" || PaymentPlanDetails?.Wings === "" || !PaymentPlanDetails?.title?.trim()?.length || (ModalType !== "Edit" && !uploadExcelFile) || failedEntriesArray?.length > 0}
                  padding={"0.85rem 3rem"}
                  btnName={"Save"}
                  clicked={OnSubmit}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>

      {isFailedEntries && <FieldEntriesModal
        open={isFailedEntries}
        handleClose={() => {
          // handleClose(false);
          setIsFailedEntries(false);
          // setOpen(true);
        }}
        fieldEntriesArray={failedEntriesArray}
        DatabaseTotal={totalEntries}
      />
      }
    </>
  );
}
